<template>
	<div>
		<div v-if="dotsLoading" class="mt-2">
			<div class="flex items-center justify-center w-full h-16 mt-4 tableCornerRadius bg-white">
				<dots-loader />
			</div>
		</div>
		<div v-else class="tableCornerRadius bg-white">
			<div class="table-container">
			<table>
				<thead>
					<th scope="col" v-for="column in columnNames || []" :key="column" class="bg-white cursor-pointer capitalize" @click="sort(column)" :class="getColumnHeadWidth(column)">
						<div v-if="column == 'documentImage'"></div>
						<div v-else-if="column == 'fileImage'"></div>
						<div v-else-if="column == 'numberOfFiles'">
							<div class="center-content flex">
								{{'Number Of Files'}}
								<!-- <div v-if="column !== 'Action'" class="sort cursor-pointer" :class="className == column ? classSort : 'opacity-50'"></div> -->
							</div>
						</div>
						<div v-else-if="column == 'createdDate'">
							<div class="center-content flex">
								{{'Created Date'}}
								<div v-if="column !== 'Action'" class="sort cursor-pointer" :class="className == column ? classSort : 'opacity-50'"></div>

							</div>
						</div>
						<div v-else-if="column == 'documentName'" class="flex">
							{{'Name'}}
							<div v-if="column !== 'Action'" class="sort cursor-pointer" :class="className == column ? classSort : 'opacity-50'"></div>
						</div>
						<div v-else-if="column == 'documentId'" class="flex">
							{{'ID'}}
							<div v-if="column !== 'Action'" class="sort cursor-pointer" :class="className == column ? classSort : 'opacity-50'"></div>

						</div>
						<div v-else-if="column == 'statusCode'">
							<div class="pl-5 flex">
								{{'Status'}}
								<div v-if="column !== 'Action'" class="sort cursor-pointer" :class="className == column ? classSort : 'opacity-50'"></div>

							</div>
						</div>
						<div v-else class="flex">
							<div v-if="column !== 'Action'">{{ column }}</div>
							<div v-if="column !== 'Action'" class="sort cursor-pointer" :class="className == column ? classSort : 'opacity-50'"></div>
						</div>
					</th>
					<tr v-if="visibility">
						<td v-for="(name, index) in columnNames || []" class="bg-white" :key="index">
							<select :class="filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="filters[name]" v-if="name == 'statusCode'">
								<option :value="filters.name" disabled selected hidden>Select</option>
								<option class="optionColors" v-for="(value, index) in docStatusValues" :key="index" :value="value.id">{{ value.value }}</option>
							</select>
							<select :class="filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="filters[name]" v-else-if="name === 'type'">
								<option :value="filters.name" disabled selected hidden>Select</option>
								<option class="optionColors" v-for="pair in docTypeData" :key="pair" :value="pair.id">{{ pair.value }}</option>
							</select>
							<select :class="filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="filters[name]" v-else-if="name == 'classification'">
								<option :value="filters.name" selected hidden disabled>Select</option>
								<option class="optionColors" v-for="pair in classificationData" :key="pair" :value="pair.id">{{ pair.value }}</option>
							</select>
							<div v-else-if="name == 'documentImage' || name == 'numberOfFiles' || name == 'createdDate'"></div>
							<div v-else-if="name == 'fileImage'"></div>
							<div v-else-if="name == 'Action'"></div>
							<div v-else>
								<input type="text" placeholder="Search" class="searchForInputBoxStyling" v-model="filters[name]" />
							</div>
						</td>
					</tr>
				</thead>

				<!-- <tbody v-if="sortedData.length == 0">
					<tr class="cursor-pointer rowHeight">
						<td class="relative h-10" :colspan="columnNames.size">
							<div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
						</td>
					</tr>
				</tbody> -->
				<tbody v-if="loadData == true">
                    <tr class="cursor-pointer empty rowHeight">
                        <td class="relative h-5" :colspan="columnNames.size">
                            <div class="flex items-center justify-center w-full h-16">
								<dots-loader/>
                            </div>
                        </td>
                    </tr>
                </tbody>
				<tbody v-else-if="sortedData.length == 0" class="emptyFixed">
					<tr class="cursor-pointer rowHeight">
						<td class="relative h-10" :colspan="columnNames.size">
							<div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
						</td>
					</tr>
               </tbody>
				<tbody class="nonEmptyTable" v-else>
					<tr v-for="(row, index) in sortedData || []" :key="row" class="cursor-pointer rowHeight">
						<td v-for="column in columnNames || []" :key="column" @mouseout="doFalse()" class="cursor-pointer relative" :class="{ 'w-20': column == 'documentImage' || column == 'fileImage' }" @click="actionOnClickingTableRow(row, index, column)">
							<!-- {{row.documentUrl[row.documentUrl.length - 1].url}} ---- ---- ----- ---- 
							{{responseurl}} -->
							<div class="table-ellipsis">
								<div v-if="column == 'documentImage'">
									<img src="@/assets/foldersIconPrimary.svg" alt="Document Icon" class="w-6 h-6" />
								</div>
								<div v-else-if="column == 'fileImage'">
									<img src="@/assets/filesIconPrimary.svg" alt="Document Icon" class="w-6 h-6" />
								</div>
								<div v-else-if="column == 'numberOfFiles' || column == 'createdDate'">
									<div class="center-content">
										{{ row[column] }}
									</div>
								</div>
								<div v-else-if="column == 'type'">
									<div @mousemove="toolTip(column, $event, index, row, 'text')">
										{{
											docTypeData.find((l) => {
												return l.id == row[column];
											}).value
										}}
									</div>
									<div v-if="pop == true && tipColumn == column && tipIndex == index">
										<tool-tip :columnName="column" :tipText="tipText" :styling="styling"></tool-tip>
									</div>
								</div>
								<div v-else-if="column == 'classification'">
									<div>
										{{
											classificationData.find((l) => {
												return l.id == row[column];
											}).value
										}}
									</div>
								</div>
								<!-- <div v-else-if="column == 'createdDate'">
									
								</div> -->
								<div v-else-if="column == 'statusCode'">
									<div class="text-center flex items-center justify-center relative rounded w-24 px-2.5 h-5 regular" :class="colorTextRequestStatus(row[column])">
										<div class="w-full h-full absolute opacity-10 rounded" :class="colorBgRequestStatus(row[column])"></div>
										<div class="flex rounded w-32 items-center justify-center py-1 regular text-xs">
											<div class="text-xs">
												{{
													docStatusValues.find((l) => {
														return l.id == row[column];
													}).value
												}}
											</div>
										</div>
									</div>
								</div>
								<div v-else-if="column === 'Action'" class="flex justify-end">
									<!-- <div class="dropdown mt-1.5" @click="toggleDropdown($event,index)">
										<div style="height: 20px; width: 20px; margin-left: 15px">
											<img src="../assets/actionsIcon.svg" alt="" />
										</div>
									</div> -->
									<!-- <div id="dropdownContainer" :class="isNearBottom(index) ? 'dropdown-up' : 'dropdown-menu1'" class="dropdown-menu rounded-full mt-2" aria-labelledby="actionDropdown" :style="dropdownStyle(index)"   v-if="clickedDropdownIndex == index && showActionPopUp">
										<div class="dropdown-item " href="#" v-for="(item, index) in dropDownData" :key="index" >
											<div v-if="item == 'Edit'" class="flex first-div">
												<div class="mr-2 ml-2">
													<img class='image' src="../assets/editIcon.svg" alt="" />
												</div>
												<div>{{ item }}</div>
											</div>
											<div v-if="item == 'View'" class="flex first-div" @click="viewclicked(row)">
												<div class="mr-2 ml-2">
													<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
														<g clip-path="url(#clip0_6206_32448)">
															<circle cx="8" cy="8" r="8" fill="#00B050" />
															<path
																d="M14.3611 7.74102C13.4485 5.47061 10.541 3.55078 8.00067 3.55078C5.46037 3.55078 2.52498 5.49843 1.63741 7.80223C1.58766 7.93115 1.58766 8.07397 1.63741 8.20289C2.52498 10.5067 5.44368 12.4543 8.00067 12.4543C10.5577 12.4543 13.4374 10.5345 14.35 8.2641C14.3797 8.19931 14.3967 8.12941 14.4001 8.05821V7.94691C14.4003 7.87643 14.387 7.80656 14.3611 7.74102Z"
																fill="#E9E9E9"
															/>
															<path d="M8.00056 9.39174C8.76888 9.39174 9.39174 8.76888 9.39174 8.00056C9.39174 7.23223 8.76888 6.60938 8.00056 6.60938C7.23223 6.60938 6.60938 7.23223 6.60938 8.00056C6.60938 8.76888 7.23223 9.39174 8.00056 9.39174Z" fill="#E9E9E9" />
															<path
																d="M8.00022 10.5043C7.50495 10.5043 7.0208 10.3575 6.609 10.0823C6.1972 9.80717 5.87624 9.41608 5.68671 8.95851C5.49718 8.50094 5.44759 7.99744 5.54421 7.51169C5.64083 7.02594 5.87933 6.57974 6.22954 6.22954C6.57974 5.87933 7.02594 5.64083 7.51169 5.54421C7.99744 5.44759 8.50094 5.49718 8.95851 5.68671C9.41608 5.87624 9.80717 6.1972 10.0823 6.609C10.3575 7.0208 10.5043 7.50495 10.5043 8.00022C10.5043 8.66435 10.2405 9.30129 9.7709 9.7709C9.30129 10.2405 8.66435 10.5043 8.00022 10.5043ZM8.00022 6.60904C7.72507 6.60904 7.4561 6.69063 7.22732 6.8435C6.99854 6.99636 6.82023 7.21363 6.71494 7.46784C6.60964 7.72204 6.58209 8.00176 6.63577 8.27163C6.68945 8.54149 6.82195 8.78937 7.01651 8.98393C7.21107 9.17849 7.45895 9.31099 7.72881 9.36467C7.99868 9.41835 8.2784 9.3908 8.5326 9.2855C8.78681 9.18021 9.00408 9.0019 9.15694 8.77312C9.30981 8.54434 9.3914 8.27537 9.3914 8.00022C9.3914 7.63126 9.24483 7.2774 8.98393 7.01651C8.72304 6.75561 8.36918 6.60904 8.00022 6.60904Z"
																fill="#00B050"
															/>
														</g>
														<defs>
															<clipPath id="clip0_6206_32448">
																<rect width="16" height="16" fill="white" />
															</clipPath>
														</defs>
													</svg>
												</div>

												<div>{{ item }}</div>
											</div>
											<div v-if="item == 'Permissions'" class="flex list-items" @click="permissionsClicked(row)">
												<div class="mr-2 ml-2">
													<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
														<g clip-path="url(#clip0_6598_36496)">
															<circle cx="8" cy="8" r="8" fill="#3497D9" />
															<path
																d="M10.0862 3.71895C10.1093 3.73905 10.1323 3.75915 10.156 3.77987C10.1752 3.79642 10.1944 3.81298 10.2141 3.83004C10.6805 4.26327 10.9206 4.8747 10.9805 5.49801C10.9893 5.77123 10.946 5.93932 10.7713 6.14705C10.5557 6.32751 10.4198 6.36352 10.1366 6.35421C9.90763 6.32853 9.77663 6.23162 9.63186 6.05733C9.53728 5.91245 9.51934 5.76924 9.50369 5.60018C9.46377 5.24038 9.32928 4.94276 9.0408 4.71151C8.65683 4.44207 8.23975 4.3633 7.78103 4.40487C7.37127 4.479 7.024 4.69082 6.78103 5.02987C6.72105 5.13117 6.66945 5.23346 6.62478 5.34237C6.61409 5.3669 6.60339 5.39143 6.59237 5.4167C6.54815 5.58303 6.55107 5.74587 6.54934 5.91732C6.54874 5.95451 6.54813 5.9917 6.54751 6.03002C6.54565 6.14845 6.54419 6.26689 6.54275 6.38533C6.54156 6.46578 6.54034 6.54622 6.53909 6.62667C6.53609 6.82356 6.53343 7.02046 6.53103 7.21737C6.56651 7.21711 6.56651 7.21711 6.6027 7.21684C7.17943 7.21269 7.75616 7.20959 8.3329 7.20765C8.61182 7.20669 8.89072 7.20537 9.16963 7.20322C9.41286 7.20135 9.65608 7.20014 9.89932 7.19972C10.028 7.19948 10.1566 7.19891 10.2853 7.19754C10.4067 7.19626 10.528 7.19588 10.6494 7.19616C10.6937 7.19611 10.738 7.19574 10.7823 7.19501C11.1154 7.18983 11.3873 7.24684 11.6405 7.47546C11.8986 7.74049 11.9199 8.00007 11.9187 8.35541C11.9188 8.39743 11.9191 8.43945 11.9193 8.48146C11.9199 8.59497 11.9198 8.70848 11.9197 8.82199C11.9196 8.91704 11.9198 9.01208 11.9199 9.10713C11.9204 9.33153 11.9203 9.55591 11.92 9.78031C11.9196 10.0111 11.9201 10.242 11.9209 10.4728C11.9216 10.6716 11.9218 10.8704 11.9216 11.0692C11.9215 11.1876 11.9216 11.3061 11.9221 11.4246C11.9226 11.536 11.9225 11.6475 11.9219 11.759C11.9217 11.8189 11.9222 11.8789 11.9226 11.9388C11.9201 12.2425 11.8609 12.5048 11.6487 12.732C11.4135 12.936 11.1389 13.0082 10.8321 13.007C10.8066 13.0071 10.7811 13.0073 10.7548 13.0074C10.6699 13.0078 10.5849 13.0077 10.4999 13.0077C10.4388 13.0079 10.3777 13.0081 10.3166 13.0083C10.1509 13.0089 9.98527 13.009 9.81959 13.0091C9.71599 13.0091 9.6124 13.0092 9.50881 13.0094C9.14718 13.01 8.78554 13.0102 8.42391 13.0102C8.08719 13.0102 7.75047 13.0108 7.41375 13.0118C7.12433 13.0126 6.83491 13.013 6.5455 13.0129C6.37278 13.0129 6.20007 13.0131 6.02736 13.0137C5.86487 13.0143 5.70238 13.0144 5.53989 13.0139C5.4804 13.0138 5.42092 13.014 5.36144 13.0144C4.97058 13.0167 4.63664 13.0072 4.33755 12.722C4.11331 12.4556 4.0661 12.1814 4.07026 11.843C4.07011 11.8006 4.06988 11.7582 4.06957 11.7158C4.06899 11.6019 4.06957 11.4879 4.0704 11.374C4.07112 11.2541 4.07086 11.1343 4.07073 11.0144C4.07068 10.8133 4.07137 10.6123 4.07252 10.4112C4.07385 10.1793 4.07406 9.94745 4.07367 9.71557C4.07332 9.49158 4.07367 9.2676 4.07437 9.04361C4.07466 8.94869 4.07472 8.85376 4.07459 8.75883C4.07447 8.64696 4.07498 8.53511 4.07596 8.42325C4.07635 8.36303 4.07614 8.30282 4.0759 8.2426C4.07979 7.92298 4.1567 7.69637 4.37478 7.4609C4.59708 7.26161 4.80565 7.21564 5.09353 7.21737C5.09326 7.19531 5.09298 7.17325 5.09269 7.15052C5.09017 6.94051 5.08827 6.73049 5.08706 6.52047C5.08641 6.41254 5.08554 6.30463 5.0841 6.19671C5.07222 5.27675 5.07222 5.27675 5.21853 4.90487C5.228 4.87905 5.23747 4.85324 5.24722 4.82664C5.27285 4.76121 5.30101 4.69847 5.33181 4.63533C5.34237 4.61336 5.35292 4.59139 5.3638 4.56875C5.70151 3.89387 6.33805 3.37631 7.04947 3.13472C8.09099 2.80901 9.24584 3.01642 10.0862 3.71895Z"
																fill="#E9E9E9"
															/>
														</g>
														<defs>
															<clipPath id="clip0_6598_36496">
																<rect width="16" height="16" fill="white" />
															</clipPath>
														</defs>
													</svg>
												</div>

												<div>{{ item }}</div>
											</div>
											<div v-if="item == 'Archive' && $route.name != 'archivedocuments'" class="flex list-items" @click="archiveClicked(row)">
												<div class="mr-2 ml-2"><img class="image" src="../assets/archiveIcon.svg" alt="" /></div>

												<div>{{ item }}</div>
											</div>
											<div v-if="item == 'Export' && $route.name != 'archivedocuments'" class="flex last-div" @click="exportClicked(row)">
												<div v-if="row.documentUrl && row.documentUrl[row.documentUrl.length - 1].url && responseurl">
													<a :href="responseurl" class="flex w-full flex-row items-center">
														<div class="mr-2 ml-2">
															<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
																<g clip-path="url(#clip0_6403_32980)">
																	<path d="M8 16C12.4182 16 16 12.4182 16 8C16 3.58172 12.4182 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4182 3.58172 16 8 16Z" fill="#152A43" fill-opacity="0.2" />
																	<path
																		d="M11.798 4H7.934C7.606 4 7.334 4.272 7.334 4.6C7.334 4.928 7.606 5.2 7.934 5.2H10.35L4.174 11.376C3.942 11.608 3.942 11.992 4.174 12.224C4.294 12.344 4.446 12.4 4.598 12.4C4.75 12.4 4.902 12.344 5.022 12.224L11.198 6.048V8.464C11.198 8.792 11.47 9.064 11.798 9.064C12.126 9.064 12.398 8.792 12.398 8.464V4.6C12.398 4.272 12.126 4 11.798 4Z"
																		fill="#152A43"
																	/>
																</g>
																<defs>
																	<clipPath id="clip0_6403_32980">
																		<rect width="16" height="16" fill="white" />
																	</clipPath>
																</defs>
															</svg>
														</div>
														<div>{{ item }}</div>
													</a>
												</div>
												<div class="flex w-full flex-row items-center" v-else>
													<div class="mr-2 ml-2">
														<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
															<g clip-path="url(#clip0_6403_32980)">
																<path d="M8 16C12.4182 16 16 12.4182 16 8C16 3.58172 12.4182 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4182 3.58172 16 8 16Z" fill="#152A43" fill-opacity="0.2" />
																<path
																	d="M11.798 4H7.934C7.606 4 7.334 4.272 7.334 4.6C7.334 4.928 7.606 5.2 7.934 5.2H10.35L4.174 11.376C3.942 11.608 3.942 11.992 4.174 12.224C4.294 12.344 4.446 12.4 4.598 12.4C4.75 12.4 4.902 12.344 5.022 12.224L11.198 6.048V8.464C11.198 8.792 11.47 9.064 11.798 9.064C12.126 9.064 12.398 8.792 12.398 8.464V4.6C12.398 4.272 12.126 4 11.798 4Z"
																	fill="#152A43"
																/>
															</g>
															<defs>
																<clipPath id="clip0_6403_32980">
																	<rect width="16" height="16" fill="white" />
																</clipPath>
															</defs>
														</svg>
													</div>
													<div>{{ item }}</div>
												
											</div>
											<div v-if="item == 'History'" class="flex last-div">
												<div class="mr-2 ml-2">
													<img class='image' src="../assets/History.svg" alt="" />
												</div>

												<div>{{ item }}</div>
											</div> 
										</div>
									</div> -->
									<Button type="button" icon="pi pi-ellipsis-v" @click="actionToggleMenu($event, index)" style="background-color: white; color: black; border: white;" />
									<Menu :ref="'menu' + index" :model="actionButtonItems(row)" :popup="true" class="menuWidth"/>

								</div>
								<div v-else @mousemove="toolTip(column, $event, index, row, 'text')" class="ellipsis-container" :class="column == 'version'?'pl-3':''">
									{{ row[column] }}
								</div>
							</div>
							<div v-if="pop == true && sortedData[tipIndex][column] == tipText && tipColumn == column && tipIndex == index">
								<tool-tip :columnName="column" :tipText="tipText" :styling="styling"></tool-tip>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		    </div>
		<pagination :dynamicPagination="dynamicPagination" @currentPageUpdate="paginationUpdations" :sortedData="sortedData"></pagination>
		
	  </div>
	</div>
</template>
<style scoped>

.ellipsis-container {
	text-overflow: ellipsis;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	line-height: 1.5em;
	max-height: 3em;	
}
.inputboxstylingForSelect .optionColors{
   color : #4D4D4D !important;
}
.table-ellipsis {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	line-break: anywhere;
}
.z-index {
	z-index: 51;
}
.severityCircle {
	height: 8px;
	width: 8px;
}
.dropdown-menu {
	border: 1px solid lightgray;
	position: absolute;
	background-color: white;
	border-radius: 6px;
	z-index: 999;
	top: 60%;
	right: 12%;
	width: 120px;
}
.dropdown-menu1 {
	border: 1px solid lightgray;
	position: fixed;
	background-color: white;
	border-radius: 6px;
	z-index: 999;
	top: 60%;
	right: 20%;
	width: 120px;
}
.list-items {
	justify-content: flex-start;
	border-bottom: 1px solid lightgray;
	padding: 5px;
}
.first-div {
	padding: 5px;
	border-bottom: 1px solid lightgray;
}
.first-div:hover {
	padding: 5px;
	background-color: lightgrey;
	border-top-left-radius: 5px;
	border-top-right-radius: 5px;
}
.last-div {
	padding: 5px;
}

.last-div:hover {
	padding: 5px;
	background-color: lightgray;
	/* border-bottom-rad; */
	border-bottom-left-radius: 5px;
	border-bottom-right-radius: 5px;
}
.list-items:hover {
	background-color: lightgray;
}
.image {
	margin-top: 2px;
}
.text-size-ten{
	font-size: 10px;
}
.inputboxstyling1 {
    display: block;
    width: 111%;
    border-radius: 0.25rem;
    border-width: 1px;
    border-style: solid;
    --tw-border-opacity: 1;
    border-color: rgba(233, 233, 233, var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
    padding-left: 0.625rem;
    padding-right: 0.625rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    line-height: 1.25rem;
    font-weight: 300;
    --tw-text-opacity: 1;
    color: rgba(77, 77, 77, var(--tw-text-opacity));
}
</style>
<script lang="ts">
import { emitter, toast } from '../main';
import _ from 'lodash';
import { defineComponent } from 'vue';
import toolTip from '../components/toolTip.vue';
import pagination from '../components/pagination.vue';
import moment from 'moment';
import dotsLoader from './dotsLoader.vue';
import { mapGetters } from 'vuex';
import 'primeicons/primeicons.css';
import Menu from 'primevue/menu';
import Button from 'primevue/button';

export default defineComponent({
	props: ['tableRowData', 'headersData', 'openPopup', 'navigate', 'documentNavigateId','fileNavigateId','loadData'],
	data(): any {
		return {
			tableHead: [],
			tableRow: [],
			searchTableRow: [],
			visibility: false,
			className: '',
			classSort: '',
			currentSort: 'name',
			currentSortDir: 'asc',
			currentPage: '',
			pageSize: '',
			responseurl: '',
			dynamicPagination: '',
			pop: false,
			styling: { left: '', bottom: '' },
			tipText: '',
			tipColumn: '',
			tipIndex: '',
            dynamicLeftPosition: 0,
            dynamicTopPosition: 0,
			filters: {},
			selectedRowIndex: '',
			showActionPopUp: false,
			clickedIndex: '',
			selectedOption: '',
			selectedDocumentName: '',
			selectedType: '',
			clickedDropdownIndex: '',
			showBlock: false,
			classificationData: [
				{
					id: 1,
					value: 'Public'
				},
				{
					id: 2,
					value: 'Internal'
				},
				{
					id: 3,
					value: 'Confidential'
				},
				{
					id: 4,
					value: 'Highly Confidential'
				},
				{
					id: 5,
					value: 'Sensitive'
				}
			],
			docTypeData: [
				{
					id: 1,
					value: 'Policies'
				},
				{
					id: 2,
					value: 'Procedures'
				},
				{
					id: 3,
					value: 'Standards'
				},
				{
					id: 4,
					value: 'Guidelines'
				}
			],
			docStatusValues: [
                {
                    id: 10411,
                    value: 'Draft' //open
                },
                {
                    id: 10415,
                    value: 'In review' //In progress
                },
                {
                    id: 10408,
                    value: 'Approved' //Accepted
                },
                // {
                //  id: 10403,
                //  value: 'Accepted' //Accepted
                // },
                // {
                //  id: 10410,
                //  value: 'Rejected' // closed
                // },
                {
                    id: 10413,
                    value: 'Published'
                },
                // {
                //     id: 10412,
                //     value: 'Archive'
                // }
            ],
			actionButtonItems(row:any){
				return[
					
					{
						label:'View',
						icon:'pi pi-eye',
						command: () => this.viewclicked(row)
					},
					{
						label:'Permissions',
						icon:'pi pi-lock',
						command: () => this.permissionsClicked(row)

					},
					{
						label:'Archive',
						icon:'pi pi-folder',
						command: () => this.archiveClicked(row)
					},
					{
						label:'Export',
						icon:'pi pi-file-export',
						command: () => this.exportClicked(row)

					},
				]
			},
			userData: [],
            mouseY: 0,
		};
	},
	components: {
		toolTip,
		pagination,
		dotsLoader,
		Menu,
		Button
	},
	async mounted() {
		this.initialize();
		emitter.on('visible', (isBoolean: any) => {
			this.visibility = isBoolean;
			this.visibility == false ? (this.filters = {}) : '';
			this.visibility == false ? (this.selectedType = '') : '';
		});
		emitter.on('*', (type, booleanValue) => {
			if (type == 'apps-sidemenubar' || type == 'toggle-sidebar') {
				this.showActionPopUp == true ? (this.showActionPopUp = false) : '';
			} else {
				if (this.showBlock === true) {
					this.showActionPopUp == true ? (this.showActionPopUp = booleanValue) : '';
				} else if (this.showBlock === false) {
					this.showActionPopUp == true ? '' : (this.showActionPopUp = booleanValue);
					this.showBlock = true;
				}
			}
		});
		
        document.addEventListener('click', this.updateMouseY);
	},
	beforeDestroy() {
        document.removeEventListener('click', this.updateMouseY);
    },
	beforeUnmount() {
        document.removeEventListener('click', this.updateMouseY);
    },
	computed: {
		sortedData: function (): any {
			return [...this.tableRow]
				.filter((row: any) => {
					for (const key in this.filters) {
						const inputValue = this.filters[key];
						if (inputValue !== '' && row[key]) {
							if (Number.isInteger(row[key])) {
								if (row[key] !== Number(inputValue)) {
									return false;
								}
							} else {
								if (!row[key].toLowerCase().includes(inputValue.toLowerCase())) {
									return false;
								}
							}
						}
					}
					return true;
				})
				.filter((item: any) => {
					if (item.Type === this.selectedType && this.selectedType !== '') {
						return true;
					} else {
						if (this.selectedType === '') {
							return true;
						} else {
							return false;
						}
					}
				})
				.sort((a, b) => {
					let modifier = 1;
					if (this.currentSortDir === 'desc') modifier = -1;
					if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
					if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
					return 0;
				})
				.filter((row, index) => {
					this.dynamicPagination = index + 1;
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
		},
		columnNames: function (): any {
			const names = new Set();
			for (const key of this.headersData) {
				if (key != '_id') names.add(key);
			}
			return names;
		},
		isClickNearBottom: function (): any {
        // Get the height of the viewport
			const viewportHeight = window.innerHeight;

			// Set a threshold for how close to the bottom counts
			const threshold = 150; // Adjust as necessary

			// Check if the last recorded mouseY is near the bottom
			return this.mouseY > (viewportHeight - threshold);
		},
		...mapGetters({ dotsLoading: 'dotsLoading' })
	},
	watch: {
		visibility(newValue) {
			if (newValue == false) {
				this.initialize();
			}
		},
		tableRowData: {
			handler(newVal, oldVal) {
				this.tableRow = this.tableRowData;
				this.initialize();
			},
			deep: true
		}
	},
	methods: {
	actionToggleMenu(event:any, index:any) {
			let menu = this.$refs['menu' + index];
			if (Array.isArray(menu)) menu = menu[0];
			if (menu && typeof menu.toggle === 'function') {
				menu.toggle(event);
			}
		},	
		// isNearBottom(index:any) {
		// 	if(((index == 0))&&((this.sortedData.length == 1))){
		// 		return false;
		// 	}else{
		// 		// Here, you can decide whether to consider the click position
		// 		return this.isClickNearBottom || index >= (this.sortedData.length); // Adjust condition based on your needs
		// 	}
		// },
		// dropdownStyle(index:any) {
		// 	const baseStyle = {
		// 		left: this.dynamicLeftPosition + 'px',
		// 		top: this.dynamicTopPosition + 'px',
		// 		display: this.showActionPopUp ? 'block' : 'none',transform:'',position:'fixed'
		// 	};
		// 	let windowWidth:any = window.innerWidth
		// 	// Only apply transform if window width is less than 1200px and certain conditions are met
		// 	if (windowWidth < 1200 && this.isClickNearBottom && index === 0) {
		// 		console.log("hjgfdgh",windowWidth < 1200);
		// 		baseStyle.transform = 'translateY(-123%)';
		// 	}

		// 	return baseStyle;
		// },
		updateMouseY(event: MouseEvent) {
            this.mouseY = event.clientY; // Capture the Y position of the mouse click
        },
		viewclicked(row:any){
			emitter.emit('viewStatus', row._id);
		},
		getColumnHeadWidth(column: any) {
            if( column == 'documentImage' || column == 'fileImage'|| column == 'Action'){
                return 'w-20';
            }else if(column == 'documentId' || column == 'version') {
                return 'w-28';
            }else if(column == 'statusCode'|| column == 'createdDate'|| column == 'type') {
                return 'w-36';
            }else if(column == 'classification') {
                return 'w-40';
            }else if(column == 'title'|| column == 'folder') {
                return 'w-80';
            }else {
                return '';
            }
        },
		// toggleDropdown(event: any, index: any) {
		// 	if (this.clickedDropdownIndex === index) {
		// 		this.clickedDropdownIndex = null;
		// 		this.showActionPopUp = !this.showActionPopUp;
		// 	} else {
		// 		this.clickedDropdownIndex = null;
		// 		this.clickedDropdownIndex = index;
		// 		this.showActionPopUp = true;
		// 	}

		// 	const currentWidth = window.innerWidth;
		// 	const { clientX, clientY } = event;

		// 	let offset: any = 0;
			
		// 	// Calculate available space below and above the cursor
		// 	const spaceBelow = window.innerHeight - clientY;
		// 	const spaceAbove = clientY;

		// 	// Position the dropdown based on available space
		// 	if (spaceBelow > spaceAbove) {
		// 		// There is space below the cursor, so show the dropdown downwards
		// 		offset = 10; // Adjust this value if needed
		// 		this.dynamicTopPosition = clientY + offset; // Position the dropdown below the click
		// 	} else if (spaceAbove > spaceBelow) {
		// 		// There is space above the cursor, so show the dropdown upwards
		// 		offset = 3; // Adjust this value if needed
		// 		this.dynamicTopPosition = clientY + offset; // Position the dropdown above the click
		// 	} else {
		// 		// If there's no space either above or below, we can close the dropdown or do nothing
		// 		this.showActionPopUp = false;
		// 		return;
		// 	}

		// 	// Handle screen width-specific offset adjustments (optional)
		// 	if (currentWidth > 1200 && currentWidth <= 1440) {
		// 		offset += 10; // Small adjustment for medium screens
		// 	} else {
		// 		offset += -2; // Small adjustment for smaller screens
		// 	}

		// 	// Horizontal position (keeping it based on clientX)
		// 	this.dynamicLeftPosition = clientX - 100; // Adjust based on your design needs
		// 	},
		permissionsClicked(data: any) {
			emitter.emit('PermissionStatus', data);
		},
		archiveClicked(data: any) {
			this.selectedDocumentName = data.selectedDocumentName;
			emitter.emit('archiveStatus', data);
		},
		async exportClicked(data: any) {
			// if(data.documentUrl && data.documentUrl[data.documentUrl.length - 1].content){
				emitter.emit('exportStatus', data);
			// }
			// if(data.documentUrl && data.documentUrl[data.documentUrl.length - 1].url){
			// 	let url = data.documentUrl[data.documentUrl.length - 1].url;
			// 	let versionId = data.documentUrl[data.documentUrl.length - 1].versionId;
			// 	let obj = {
			// 		link: url,
			// 		versionId: versionId
			// 	};
			// 	await this.$http.post(`${process.env.VUE_APP_FILE_API_URL}/presignedurl`, obj).then(async (res: any) => {
			// 		if(res.status == 200){
			// 			this.pageStatus = true
			// 		}
			// 		this.responseurl = res.data;
			// 		toast.info(`Exported`, {
			// 			closeOnClick: true,
			// 			closeButton: 'button'
			// 		});
			// 		// this.triggerDownload(this.responseurl);
			// 		// let anchor = document.createElement('a');
			// 		// anchor.href = this.responseurl;
			// 		// anchor.download
			// 		// anchor.click();
			// 		// await this.getAllDocumentsList();
			// 	});
			// }
		},
		triggerDownload(url: any) {
			const anchor = document.createElement('a');
			anchor.href = url;
			anchor.download = ''; // Optionally set a default filename
			document.body.appendChild(anchor);
			anchor.click();
			document.body.removeChild(anchor);
		},
		initialize() {
			this.tableRow = this.tableRowData;
			this.searchTableRow = this.tableRowData;
		},
		paginationUpdations(currentPage: any, pageSize: any) {
			this.currentPage = currentPage;
			this.pageSize = pageSize;
		},
		sort(tableHead: any) {
			this.className = tableHead;
			if (tableHead === this.currentSort) {
				this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
			}
			this.currentSort = tableHead;
			this.classSort = this.currentSortDir === 'asc' ? 'sort_asc' : 'sort_desc';
		},
		toolTip(column: any, e: any, index: any, row: any, status: any) {
			if(column == 'type'){
				this.tipText = this.docTypeData.find((l:any) => {
					return l.id == row[column];
				}).value
			}else{
				this.tipText = row[column];
			}
			this.tipColumn = column;
			this.tipIndex = index;

			switch (status) {
				case 'text':
					this.handleTextTooltip(e);
					break;
			}
		},
		actionOnClickingTableRow(rowData: any, index: any, column: any) {
			// emitter.emit('rowData',rowData)
			if (this.documentNavigateId == 10001 && this.navigate == true) {
				localStorage.setItem('DOCUMENT_DATA', JSON.stringify(rowData));
				this.$router.push({ name: 'fileslist' });
			}else if(this.fileNavigateId == 10002 && this.navigate == true){
                this.$router.push({ name: 'editor', params: { documentId: rowData._id, type: 'fileslist' } });
            }
			 else if (this.openPopup == true && this.navigate == false) {
				let popupdata = {
					entityData: rowData,
					indexx: index
				};
				emitter.emit('showData123', popupdata);
			} else if (this.openPopup == true && column != 'Action') {
				let popupdata = {
					entityData: rowData,
					indexx: index
				};
				emitter.emit('showData123', popupdata);
			} else if (this.$route.path.includes('approvals')) {
				emitter.emit('rowData', rowData);
			}
			this.showBlock = false;
		},
		colorTextRequestStatus(status: any) {
			if (status == 10411) {
				return ['text-darkred', 'border-solid border border-darkred font-semibold'];
			} else if (status == 10415) {
				return ['text-yellow', 'border-solid border border-yellow font-semibold'];
			} else if (status == 10408) {
				return ['text-primary', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-primary'];
			}
			// else if (status == 10412) {
			//     return ['text-darkred', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-darkred'];
			// }
			else if (status == 10413) {
				return ['text-lightgreen', 'flex justify-center px-2.5 py-1 font-semibold border-solid border border-lightgreen'];
			}
		},
		colorBgRequestStatus(code: any) {
			if (code == 10411) {
				return ['bg-darkred'];
			} else if (code == 10415) {
				return ['bg-yellow'];
			} else if (code == 10408) {
				return ['bg-primary', 'opacity-10'];
			}
			// else if (code == 10412) {
			//     return ['bg-darkred', 'opacity-10'];
			// }
			else if (code == 10413) {
				return ['bg-lightgreen', 'opacity-10'];
			}
		},
		handleTextTooltip(e: any) {
			const container = e.currentTarget.closest('.table-ellipsis');
			if (container && this.isTextOverflowed(container)) {
				this.pop = true;
				this.styling.left = e.offsetX + 24 + 'px';
				this.styling.top = 48 + 'px';
			} else {
				this.pop = false;
			}
		},
		isTextOverflowed(element: any) {
			return element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight;
		},
		doFalse() {
			this.pop = false;
		},
		// handleDropdownSelection(status: any, data: any) {
		// 	if (status == 'Permissions') {
		// 		emitter.emit('PermissionStatus', data);
		// 	} else if (status == 'Archive') {
		// 		emitter.emit('archiveStatus', data._id);
		// 	} else if (status == 'View') {
		// 		// this.$router.push({name:'editor'})
		// 		emitter.emit('viewclicked', data._id);

		// 	}
		// }
	}
});
</script>
